const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('flarum-tags', 'common/utils/sortTags');